export default __webpack_public_path__ + "static/media/server-error.f458bc62.svg";